import React from "react";
import { Heart, Instagram, Camera } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_digital-studio-pro/artifacts/5kz5nw0k_logo_key4.png"
                alt="Web Key Studio"
                className="h-8 w-auto"
              />
              <span className="text-lg font-bold bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent">
                Web Key Studio
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Créateur digital freelance spécialisé dans le développement web, 
              la création de logos et l'accompagnement de projets digitaux.
            </p>
            <p className="text-slate-500 text-xs italic">by Mike</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <nav className="space-y-2">
              <button
                onClick={() => {
                  const element = document.getElementById("hero");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="block text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
              >
                Accueil
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById("about");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="block text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
              >
                À propos
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById("projects");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="block text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
              >
                Réalisations
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById("services");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="block text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
              >
                Services
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById("contact");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="block text-slate-400 hover:text-cyan-400 transition-colors duration-300 text-sm"
              >
                Contact
              </button>
            </nav>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Suivez-moi</h3>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/webkey_studio"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300"
              >
                <Instagram className="text-white" size={18} />
              </a>
              <a
                href="https://snapchat.com/add/webkeystudio"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300"
              >
                <Camera className="text-white" size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-1 text-slate-400 text-sm">
              <span>© {currentYear} Web Key Studio. Fait avec</span>
              <Heart className="text-red-400 fill-current" size={16} />
              <span>by Mike</span>
            </div>
            
            <div className="flex space-x-6 text-slate-400 text-sm">
              <a href="/mentions-legales.html" className="hover:text-cyan-400 transition-colors duration-300">
                Mentions légales
              </a>
              <a href="/politique-confidentialite.html" className="hover:text-cyan-400 transition-colors duration-300">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>

        {/* Back to Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-cyan-500 to-violet-500 rounded-full flex items-center justify-center text-white hover:shadow-lg hover:shadow-cyan-500/25 transition-all duration-300 hover:scale-110 z-40"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      </div>
    </footer>
  );
};

export default Footer;